import React, { useState, useEffect } from "react";
import { IoMdAddCircle } from "react-icons/io";
import ToastNotification from "../../components/ToastNotification/ToastNotification";
import axios from 'axios';
import { RiDeleteBin6Fill } from "react-icons/ri";
import ConfirmDialog from "../../components/ToastNotification/ConfirmModal";
import { FiCheckCircle } from "react-icons/fi";
import { FaCircleXmark } from "react-icons/fa6";
function TimeSlot() {
  const [showForm, setShowForm] = useState(false);
  const [editingCompanyId, setEditingCompanyId] = useState(null);
  const [isEditMode, setIsEditMode] = useState(false);
  const [searchTerm, setSearchTerm] = useState('');
  const [fetchTime, setFetchTime] = useState([]);
  const [formData, setFormData] = useState({
    work_time: ''
  });
  const [toast, setToast] = useState({
    show: false,
    message: '',
    bg: 'success'
  });
  const showToast = (msg, bg = 'success') => {
    setToast({
      show: true,
      message: msg,
      bg
    });
  };
  const [confirmDialog, setConfirmDialog] = useState({
    show: false,
    title: '',
    message: '',
    onConfirm: null
  });
  const showConfirmDialog = ({
    title,
    message,
    onConfirm
  }) => {
    setConfirmDialog({
      show: true,
      title,
      message,
      onConfirm: () => {
        onConfirm();
        setConfirmDialog({
          ...confirmDialog,
          show: false
        });
      }
    });
  };
  const handleInputChange = e => {
    const {
      name,
      value,
      files
    } = e.target;
    if (name === "image") {
      setFormData({
        ...formData,
        [name]: files[0]
      });
    } else {
      setFormData({
        ...formData,
        [name]: value
      });
    }
  };
  const handleCancel = () => {
    setShowForm(false);
    setIsEditMode(false);
    resetForm();
  };
  const handleEdit = async form => {
    setIsEditMode(true);
    setFormData({
      id: form.id,
      work_time: form.work_time || ""
    });
    setEditingCompanyId(form.id);
    setShowForm(true);
  };
  const handleDelete = async id => {
    try {
      await axios.delete(`https://api.sweepydo.in/delet-work-slot/${id}`);
      showToast("Work slot deleted successfully", 'success');
      fetchTimeSlot();
    } catch (err) {
      console.error("Error deleting role:", err);
      showToast("Failed to delete work slot", 'danger');
    }
  };


  const handleSlotStatus = async (id, status) => {
    try {
await axios.put(
      `https://api.sweepydo.in/update-slot-status/${id}`,
      { status: status }
    );
          showToast(`Work slot ${status == 1 ? 'activated' : 'inactivated'} successfully`, 'success');
      fetchTimeSlot();
    } catch (err) {
      console.error("Error updating slot:", err);
      showToast("Failed to update work slot", 'danger');
    }
  };

  const handleSubmit = async e => {
    e.preventDefault();
    try {
      const res = await axios.post("https://api.sweepydo.in/add-working-slot", {
        work_time: formData.work_time
      });
      fetchTimeSlot();
      setShowForm(false);
      setFormData({
        work_time: ''
      });
      showToast('Working Time Added successfully!', 'success');
    } catch (err) {
      const message = err.response?.data?.message;
      if (message === "Pincode already exists") {
        showToast('Pincode already exists!', 'warning');
      } else {
        showToast('Fail to add working time!', 'danger');
      }
      console.error("❌ Error:", message || err.message);
    }
  };
  useEffect(() => {
    fetchTimeSlot();
  }, []);
  const fetchTimeSlot = async () => {
    try {
      const res = await axios.get("https://api.sweepydo.in/fetch-all-time-slot");
      setFetchTime(res.data);
    } catch (error) {
      console.log(error);
    }
  };
  const resetForm = () => {
    setFormData({
      pincode: '',
      city: ''
    });
  };
  const filteredData = Array.isArray(fetchTime) ? fetchTime.filter(itm => Object.values(itm).some(val => String(val).toLowerCase().includes(searchTerm.toLowerCase()))) : [];
  const formatTime = time => {
    const [hours, minutes] = time.split(":");
    const date = new Date();
    date.setHours(hours, minutes);
    return date.toLocaleTimeString([], {
      hour: "numeric",
      minute: "2-digit",
      hour12: true
    });
  };
  return <div 
  className="main-page"
  >
          <ToastNotification show={toast.show} message={toast.message} bg={toast.bg} onClose={() => setToast({
      ...toast,
      show: false
    })} />
      <p className="main-page-heading">Manage Time Slots</p>

      
 {showForm && <div className="main-page-area mb-3">
          <form onSubmit={handleSubmit}>
              <div className="col-md-6">
                <label className="form-label">Work Time </label><br />
                <input type="time" name="work_time" value={formData.work_time} onChange={handleInputChange} className="col-md-6 main-input-control" required />
              </div>

            


            <div className="d-flex justify-content-end">
              
              <button type="submit" className="btn main-btn1 me-2">
                {isEditMode ? "Update" : "Save"}
              </button>

              <button onClick={handleCancel} className="btn main-btn2">
                Cancel
              </button>
            </div>
          </form>

        </div>}

  <div className="main-page-area" 
  >
   <div className="d-flex justify-content-between align-items-center mb-3 flex-wrap gap-2">
      
          
              <input type="text" className="main-input-control" placeholder="Search ..." value={searchTerm} onChange={e => setSearchTerm(e.target.value)} />

             <div className="d-flex jsutify-conetnt-end gap-2">
 
  


      
              <button className="btn main-btn1" onClick={() => {
            setShowForm(true);
          }}>
                <IoMdAddCircle /> Add
              </button>

              </div>
            </div>
      
            <div className='table-responsive main-page-table'>
              <table className="w-100 table text-center">
                <thead>
                  <tr>
                    <th>SN</th>
                    <th>Work Time</th>

                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
      
                  {filteredData.map((s, i) => <tr key={s.id} 

            >
                      <td>{i + 1}</td>
                      <td>  {formatTime(s.work_time)} </td>
                     
                  
                      <td>
                        
                        <RiDeleteBin6Fill size={20} title="Delete" className="mx-2 text-danger" onClick={() => showConfirmDialog({
                  title: 'Delete work slot',
                  message: `Are you sure you want to delete  this work slot ?`,
                  onConfirm: () => handleDelete(s.id)
                })} />

{s.is_active == 1 ?    <FaCircleXmark size={20} title="Inactive" className="cursor-pointer text-danger" onClick={() => showConfirmDialog({
                  title: 'Inactive this slot',
                  onConfirm: () => handleSlotStatus(s.id, 0)
                })} />
              :    <FiCheckCircle size={20} title="Active" className="cursor-pointer text-success" onClick={() => showConfirmDialog({
                  title: 'Active this slot',
                  onConfirm: () => handleSlotStatus(s.id, 1)
                })} />}

                                     

                      </td>



                    </tr>)}
                </tbody>
              </table>
            </div>

 </div>           
      
            <ConfirmDialog show={confirmDialog.show} title={confirmDialog.title} message={confirmDialog.message} onConfirm={confirmDialog.onConfirm} onCancel={() => setConfirmDialog({
      ...confirmDialog,
      show: false
    })} />
      

    </div>;
}
export default TimeSlot;
